import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/clients")({
  component: ClientsLayout,
});

function ClientsLayout() {
  return (
    <RouteGuard module="clients" action="read">
      <Outlet />
    </RouteGuard>
  );
}
